module.exports = __webpack_public_path__ + "img/indiana-jones-cgr-2024.77fb963d.jpg";